module.exports = __webpack_public_path__ + "0d9087840afac9a34ca24e02f72fa82c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/quiz-icons/open-ss-complete.png
// module id = 2923
// module chunks = 0